module.exports = __webpack_public_path__ + "img/vitality_logo.e0034f3c.jpg";